<div class="upload-container"
    (click)="triggerFileInput()" 
     (dragover)="onDragOver($event)" 
     (dragleave)="onDragLeave($event)" 
     (drop)="onDrop($event)" 
     [class.dragover]="isDragging">

    <p>Arrastra y suelta los archivos aquí o haz clic para seleccionar</p>
    <input type="file" #fileInput multiple (change)="onFilesSelected($event)" hidden>
</div>

@if (selectedFiles.length > 0) {
    <div class="files-container">
      <h3>📁 Archivos seleccionados</h3>
      <ul>
        @for (file of selectedFiles; let index = $index; track index) {
          <li class="file-item">
            <div class="file-info">
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">{{ formatSize(file.size) }}</span>
            </div>
            <button (click)="removeFile(index)">❌</button>
          </li>
        }
      </ul>
    </div>
}

<div class="upload-button-container">
    <button (click)="uploadFiles()" [disabled]="selectedFiles.length === 0">Subir Archivos</button>
</div>
  
